<template>
  <div style="display:flex;">
    <div style="width: 200px;">后台管理系统</div>
    <div style="flex:1;font-size: 40px;font-style:italic;font-weight: bold;">
      小 城 十 月
    </div>
    <div style="width: 150px;">
      <el-dropdown @command="handleCommand">
        <i class="el-icon-setting" style="margin-right: 15px"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="out">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span>管理员</span>
    </div>
  </div>
</template>

<script>
import { removeToken } from "../utils/authUtils";
export default {
  name: "Header",

  methods: {
    handleCommand(command) {
      if ("pwd" == command) {
      } else if ("out" == command) {
        removeToken();
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dhome/DHeader.vue